<template>
  <SwapMenu2 :swapid="swapid" :period="period" :title="mytitle" :margin="widthclass">
    <template v-slot:menu>
    <li><a class="dropdown-item" @click=start_interval()>Save Graph</a></li>
    </template>
  </SwapMenu2>
  <canvas :id="canvasid" width="850" height="300"></canvas>
</template>

<script>
import LineGraph from '../js/linegraph.js'
import SwapMenu2 from './SwapMenu2.vue' 
export default {
  name: 'LineGraph',
  components : {
      SwapMenu2 
  },
  props: {
    swapid : String,
    globid : String,
    subtype : String         // tps or apr
  },
  data() {
      return {
         interval : 0,
         lastswapid : 0,
         linegraph : null,
         options : null,
         graphdata : { "pswline" : "", "slot" : 0, 
                       "draw" : 0,
                       "prev_recvrate" : 100,
                        "prev_sendrate" : 100,  
                        "data" : null },
         colors : [ "#a55ca5", "#67b6c7", "#bccd7a", "#eb9743", "#a39359",
                    "#93cc52", "#884499", "#3355ff", "#ee22ff", "#ffff00" ]
      }
  },
  computed : {
    canvasid() { return "lineg" + this.globid + this.widthclass; },
    mytitle() { if (this.options) return this.options.seriesName ;
                return this.subtype ; 
              },
    swapseq() {
        let swap = this.$store.getters.getswap_byid(this.swapid) ;
        if (! swap) return 0 ;
        return swap.seq ;
    }
  },
  watch : {
    swapseq : function () {
        // console.log ("swapseq change " + this.lastswapid + " " + this.swapid) ;
        if (this.lastswapid == this.swapid) 
            this.draw() ;
        else
            this.initdraw() ;
    }
  },
  methods : {
     stop_interval() {
         if (this.interval) {
            clearInterval(this.interval) ;
            this.interval = 0 ;
         }
     },
     start_interval() {
         if (this.interval == 0) {
            this.interval = setInterval( () => 
                { this.$store.commit("reqswapdata",  this.swapid) 
                  console.log ("linegraph draw:" + this.graphdata.draw + " key :" + 
                            this.$.vnode.key) ;
                  if (this.graphdata.draw != this.swapseq && 
                                this.graphdata.draw == 0)
                      this.$.vnode.key = this.swapseq ; 
                      this.draw()
                }, this.period) ;
         }
     },
     getaprrate() {
        let g = this.graphdata ;
        if ( ! g.data ) return  { "send" : 0, "recv" : 0 }

        let newdata = this.getdata() ;
        if (! newdata ) return  { "send" : 0, "recv" : 0 }

        let recv, recv00, recvrate ;

        recv = newdata.recv - g.data.recv ;
        recv00 = newdata.recv00 - g.data.recv00 ;

        if (recv == 0) recvrate = 100 ;
        else recvrate = recv00 * 100 / recv ;

        let send, send00, sendrate;

        send = newdata.send - g.data.send ;
        send00 = newdata.send00 - g.data.send00 ;
        if (send == 0) sendrate = 100 ;
        else sendrate = send00 * 100 / send ;

        g.data = newdata ;
        return { "send" : sendrate, "recv" : recvrate }
     },
     gettpsrate() {
        let g = this.graphdata ;
        if ( ! g.data ) return  { "send" : 0, "recv" : 0 }

        let newdata = this.getdata() ;
        if (! newdata ) return  { "send" : 0, "recv" : 0 } 

        if (g.data.recv == 0 && g.data.send == 0)
            return { "send" : 0, "recv" : 0 } 

        let tottime = newdata.time - g.data.time;
        if (tottime < 1) tottime = 1 ;

        let recv = (newdata.recv - g.data.recv) / tottime ; // tps
        let send = (newdata.send - g.data.send) / tottime ; // tps
        if (send > 500) 
            alert ("send " + send + " time " + tottime ) ;
        g.data = newdata ;
        return { "send" : send, "recv" : recv}
     },
    getdata() {
        let swap = this.$store.getters.getswap_byid( parseInt(this.swapid )) ;
        if (! swap || ! swap.sdata || ! swap.sdata.txdata ) 
            return null ;
        let tx = swap.sdata.txdata ;
        return ( { "recv" : tx["totinc"], "send" : tx["totout"],
                   "recv00" : tx["c109"], "send00" : tx["c110" ],
                   "time" : parseInt(tx["c127"])
                 } ) 
    },
    initdraw(data, ginfo) {     // APRRATE, RESPOSETIME, VOLUME      data:x,y
        console.log ("initdraw " + this.swapid) ;
        let myCanvas = document.getElementById(this.canvasid);
        if (! myCanvas) 
            return console.log ("initdraw canvas null: " + this.canvasid) ;

        // let legend = document.querySelector("legend[for='" + this.canvasid + "']");
        let newcolors = this.colors ;

        let options = {
          canvas: myCanvas,
          seriesName: "Approval Rate",
          padding:30,
          gridScale:10,
          maxValue: 100,
          xScale : 20,
          unit : '%',
          unitstart : 0,
          Xunit : '',
          gridColor:"#eeeeee",

          data: data,
          colors: newcolors,

          titleOptions: {
            align: "center",
            fill: "black",
            font: {
              weight: "bold",
              size: "18px",
              family: "Lato"
            }
          }
        }
        this.options = options ;
        let g = this.graphdata;

        g.slot = 0 ;
        g.pswline = this.swapid ;
        g.data = data ;

        let vtitle = ginfo.md.toUpperCase() ;

        if (ginfo.model == "APRRATE") {
          options.maxValue = 100.0 ;
          options.unit = '%' ;
        }
        else {  /* volume or response */
          let maxval = 0.0 ;
          for (let i = 0 ; i < data.length ;i++) {
            if (maxval < parseFloat(data[i][1]))
                maxval = parseFloat(data[i][1])
          }
          options.maxValue = maxval ;
          options.unit = '' ;
        }

        options.Xunit = '' ;
        if (ginfo.model == "APRRATE") 
          vtitle = vtitle + " APPROVAL RATE " ;
        else
        if (ginfo.model == "VOLUME") 
          vtitle = vtitle + " TRANS VOLUME " ;
        else {
          options.Xunit = 'usec' ;
          vtitle = vtitle + " RESPONSE TIME " ;
        }

        if (ginfo.md == "monthly") {
          vtitle = vtitle + ginfo.month ;
          options.xScale = 31 ; // 31 days
          options.unitstart = 1 ;    // unit start ;
          for (let i = 0 ; i < data.length ; i++) {
            let xlab = data[i][0] ;      // yymmdd 
            let len = xlab.length ;
            let day = xlab.substr(len - 2) ;
            data[i][0] = (parseInt(day) - 1) / 31 ;
          }
        }
        else {
          vtitle = vtitle + ginfo.day ;
          options.xScale = 24 ; // 24 hours
          options.unitstart = 0 ;    // unit start ;
          for (let i  = 0 ; i < data.length ; i++) {
            let xlab = data[i][0] ;      // in minute 1440 = 1 days
            data[i][0] = parseInt(xlab) / 1440 ;
          }
        }
        if (ginfo.base == 'OUTR' || ginfo.base == 'INCR')
            vtitle = vtitle + ' - ' + ginfo.resp ;
        else
            vtitle = vtitle + ' - ' + ginfo.proc ;
        this.options.seriesName = vtitle ;
        this.linegraph = new LineGraph(options);
        this.linegraph.draw();
        this.linegraph.drawLines(data, "#0000FF") ;
    },
  }
}
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
</script>

